<template>
    <div class="w-full mb-4" v-for="modification in modifications">
        <InputLabel class="mb-1" :value="modification.title"/>

        <div class="flex gap-2 flex-wrap">
            <div
                v-for="option in modification.options"
                class="border-2 border-black px-2 whitespace-nowrap cursor-pointer"
                :class="{
                    'bg-indigo-500': isOptionSelected(modification, option),
                    'bg-gray-300': !option.is_available
                }"
                @click="selectModification(modification, option.id)"
            >
                <span
                    class="text-sm font-bold"
                    :class="{ 'text-white': isOptionSelected(modification, option) }"
                >
                    {{ option.title }}
                    {{ !option.is_available && isOptionSelected(modification, option) ? '⚠️' : '' }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import InputLabel from "@/Components/InputLabel.vue";

export default {
    components: {InputLabel},
    props: {
        modifications: Array,
        selectedOptions: Array,
        variants: {
            type: Object,
            default: {}
        },
        productVariant: Object
    },
    emits: ['changed'],
    methods: {
        isOptionSelected(modification, option) {
            return this.selectedOptions
                .find((options) => options.modification_id === modification.id)
                .options
                .includes(option.id)
        },
        selectModification(modification, optionId) {
            this.selectedOptions
                .find((options) => options.modification_id === modification.id)
                .options = [optionId]

            this.$emit('changed')
        },
    },
    created() {
        const variantOptions = this.productVariant?.slug.split('-') || [];

        this.modifications
            .forEach(modification => {
                const options = []

                modification.options.forEach(option => {
                    if (variantOptions.length) {
                        if (variantOptions.includes(option.id.toString())) {
                            options.push(option.id)
                        }

                        return;
                    }

                    if (option.is_default || modification.options.length === 1) {
                        options.push(option.id)
                    }
                })

                this.selectedOptions.push({
                    modification_id: modification.id,
                    options
                })
            })
    }
}
</script>
